<svelte:head>
  <title>{status || params.status}</title>
</svelte:head>

<div class="error-wrapper">
  <h1>{status || params.status}</h1>

  <p>{error ? error.message : params.message}</p>
</div>
<style>
  .error-wrapper {
    margin: 20px;
  }

  h1, p {
    margin: 0 auto;
  }

  h1 {
    font-size: 2.8em;
    font-weight: 700;
    margin: 0 0 0.5em 0;
  }

  p {
    margin: 1em auto;
    font-family: monospace;
    white-space: pre-wrap;
  }

  @media (min-width: 480px) {
    h1 {
      font-size: 4em;
    }
  }
</style>
